import styled from 'styled-components';

import { NegativeMarginProps } from './negative-margin';


const Root = styled.div<NegativeMarginProps>`
	margin: ${p => `0 -${p.value}px` };
`;

export {
	Root
}